

























import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import axios from 'axios';
import { IAuth0 } from '@/interfaces/data';
import AdminTreeView from '@/components/AdminTreeView.vue';
import UserTreeView from '@/components/UserTreeView.vue';
import CoverageStatsView from '@/components/CoverageStatsView.vue';
import MarkerFilteringView from '@/components/MarkersFilteringView.vue';
import GoogleMapView from '@/components/GoogleMapView.vue';
import OverLayView from '@/components/OverLayView.vue';

@Component({
  components: {
    AdminTreeView,
    UserTreeView,
    CoverageStatsView,
    MarkerFilteringView,
    GoogleMapView,
    OverLayView
  }
})
export default class HomeView extends Vue {
  // private setPlace(place) {
  //   console.log(place);
  //   this.$refs.mapRef.center = {
  //     lat: place.geometry.location.lat(),
  //     lng: place.geometry.location.lng()
  //   };
  //   // this.searchBoxMarker = {
  //   //   lat: place.geometry.location.lat(),
  //   //   lng: place.geometry.location.lng()
  //   // };
  // }
  // addMarker() {
  //   if (this.searchBoxMarker) {
  //     const marker = {
  //       lat: this.searchBoxMarker.geometry.location.lat(),
  //       lng: this.searchBoxMarker.geometry.location.lng()
  //     };
  //     this.tempMarkers.push({
  //       position: marker,
  //       coverage: false,
  //       coverageStatus: '0,0,0',
  //       projectId: 0
  //     });
  //   }
  // }
}
